import { render, staticRenderFns } from "./MapPolygon.vue?vue&type=template&id=0d454559&"
import script from "./MapPolygon.vue?vue&type=script&lang=ts&"
export * from "./MapPolygon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports